export default "__VITE_ASSET__e6c5fc98__"